"use strict";

var _classCallCheck = require("/home/illing/code/udacity/blockchain/alpacoin/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/illing/code/udacity/blockchain/alpacoin/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var semver_1 = __importDefault(require("semver"));

var VersionsManager = /*#__PURE__*/function () {
  /**
   * @param componentVersion - a semver of a component that uses the VersionsManager
   * @param requiredVersionRange - a semver that has to be satisfied by the
   */
  function VersionsManager(componentVersion, requiredVersionRange) {
    _classCallCheck(this, VersionsManager);

    if (semver_1.default.valid(componentVersion) == null) {
      throw new Error('Component version is not valid');
    }

    if (requiredVersionRange == null) {
      var ver = new semver_1.default.SemVer(componentVersion);
      ver.patch = 0;
      requiredVersionRange = '^' + ver.format();
    }

    this.requiredVersionRange = requiredVersionRange;
  }
  /**
   * @param version - the version of a dependency to compare against
   * @return true if {@param version} satisfies the {@link requiredVersionRange}
   */


  _createClass(VersionsManager, [{
    key: "isRequiredVersionSatisfied",
    value: function isRequiredVersionSatisfied(version) {
      // prevent crash with some early paymasters (which are otherwise perfectly valid)
      version = version.replace('_', '-');
      return semver_1.default.satisfies(version, this.requiredVersionRange, {
        includePrerelease: true
      });
    }
  }]);

  return VersionsManager;
}();

exports.VersionsManager = VersionsManager;